import { Collapse } from "bootstrap";

const US = 1;
const zip = document.getElementById('organization-zip');
const form = document.querySelector('.deployment-form');
const state = document.getElementById('organization-state');
const submitButton = document.getElementById('submit-button');
const email = document.getElementById('organization-admin-email');
const country = document.getElementById('organization-country-id');
const stateZipContainer = document.querySelector('.state-zip-container');
const stateZipContainerCollapse = new Collapse(stateZipContainer, { toggle: false });
const confirmEmail = document.getElementById('organization-admin-email-confirmation');
const emailErrorMessageElement = document.querySelector('#organization-admin-email ~ .invalid-feedback');
const confirmEmailErrorMessageElement = document.querySelector('#organization-admin-email-confirmation ~ .invalid-feedback');

window.addEventListener('DOMContentLoaded', () => {
    formValidation();
    emailValidation();
    countryValidation();
});

function formValidation() {
    submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        form.classList.add('was-validated');

        if (form.checkValidity() === false) {
            scrollFirstErrorIntoView();
        } else {
            grecaptcha.execute();
        }
    });
}

function countryValidation() {
    country.addEventListener('change', (event) => {
        if (event.target.value == US) {
            stateZipContainerCollapse.show();

            zip.setAttribute('required', 'required');
            zip.setAttribute('aria-required', 'true');
            state.setAttribute('required', 'required');
            state.setAttribute('aria-required', 'true');

            return;
        }

        zip.removeAttribute('required');
        zip.removeAttribute('aria-required');
        state.removeAttribute('required');
        state.removeAttribute('aria-required');

        stateZipContainerCollapse.hide();
    });
}

function emailValidation() {
    email.addEventListener('blur', () => {
        email.closest('div').classList.add('was-validated');
    });

    confirmEmail.addEventListener('blur', () => {
        confirmEmail.closest('div').classList.add('was-validated');
    });

    email.addEventListener('input', () => {
        if (email.validity.valueMissing) {
            emailErrorMessageElement.textContent = 'Email is required';
            return;
        }

        if (email.validity.typeMismatch) {
            emailErrorMessageElement.textContent = 'Email is not a valid email';
            return;
        }

        email.setCustomValidity('');

        if (confirmEmail.value !== '' && emailsMatch()) {
            confirmEmail.setCustomValidity('');
        }
    });

    confirmEmail.addEventListener('input', () => {
        if (confirmEmail.validity.valueMissing) {
          confirmEmailErrorMessageElement.textContent = 'Confirm Email is required';
          return;
        }

        if (confirmEmail.validity.typeMismatch) {
            confirmEmailErrorMessageElement.textContent = 'Email is not a valid email';
            return;
        }

        if (emailsMatch()) {
            confirmEmail.setCustomValidity('');
        }
    });

    function emailsMatch() {
        if (email.value === confirmEmail.value) {
            return true;
        }

        confirmEmailErrorMessageElement.textContent = 'The Emails you entered do not match'
        confirmEmail.setCustomValidity(confirmEmailErrorMessageElement.textContent);

        return false;
    }
}

function scrollFirstErrorIntoView() {
    const invalidInput = form.querySelector('.form-control:invalid');
    invalidInput.scrollIntoView({block: "nearest", inline: "nearest", behavior: 'smooth'});
    invalidInput.focus();
}
